import React from 'react';
import { useAnalytics, useRequestUrl } from '../hooks';
import { GenericShareButton, InnerShareButton } from './social-sharing.styles';
import { FacebookIcon } from './icons';
export function FacebookShareButton({ block = false, buttonColor = '#4267B2', //facebook brand blue
buttonText = 'Facebook', buttonTextColor = 'white', iconColor = 'white', shareUrl = useRequestUrl() }) {
    const { sendTrackEvent } = useAnalytics();
    const url = encodeURI(`https://www.facebook.com/sharer/sharer.php?u=${shareUrl}`);
    return (React.createElement(GenericShareButton, { block: block, buttonColor: buttonColor, colorOverride: buttonTextColor, href: url, title: "Facebook", onClick: () => sendTrackEvent('clickedAnchor', {
            event: 'clicked',
            eventComponent: 'FacebookShareButton',
            label: buttonText,
            href: url
        }) },
        React.createElement(InnerShareButton, null,
            React.createElement(FacebookIcon, { color: iconColor }),
            React.createElement("span", null, buttonText))));
}
//# sourceMappingURL=FacebookShareButton.js.map